import { useCallback } from 'react';
import useTrackCustomMetric from './useTrackCustomMetric';
import { useThirdPartyTags } from './useSiteConfig';
import { openInsideChatTab } from '../page/components/inside-chat';

const openChatWindow = options => {
    try {
        const { chatRule, enableMoxie, chatReferer, chatFrom, enableInsideChat, insideChatUrl } = options || {};
        if (enableInsideChat && insideChatUrl && insideChatUrl.length > 0) {
            openInsideChatTab();
        } else if (enableMoxie) {
            // Confirms that Concierge is ready
            chatReferer &&
                chatFrom &&
                window.conciergeReady.then(function () {
                    window.GoMoxie.conciergeV2.channelsData({
                        nareferer: chatReferer,
                        usertype: '',
                        chatFrom: chatFrom,
                    });
                });
            window.startMoxieEngagement(chatRule);
        } else if (window.openChatWindow) {
            openChatWindow(options);
        } else {
            //fallback to explicit Genesys chat logic of moxie isn't enabled and no global chat function defined
            window.Genesys(
                'command',
                'Messenger.open',
                {},
                function (o) {
                    // if resolved
                },
                function (o) {
                    // if rejected
                    window.Genesys('command', 'Messenger.close');
                },
            );
        }
    } catch (e) {}
};

/**
 * Returns the redux state for the Cart
 * @name useChat
 * @returns {openChat}
 */
export default function useChat(options = {}) {
    const { enableMoxie, enableInsideChat, insideChatUrl } = useThirdPartyTags([
        'enableMoxie',
        'enableInsideChat',
        'insideChatUrl',
    ]);
    const openChat = () => {
        openChatWindow({ enableMoxie, enableInsideChat, insideChatUrl, ...(options || {}) });
    };
    return {
        openChat,
    };
}
